import { TFunction } from 'i18next';

export const MAX_EXPERIENCE_YEARS = 99;

export const splitMonthsExperience = (
  months: number | null | undefined,
): { years: number | null; months: number | null } => {
  if (months === null || months === undefined) {
    return { years: null, months: null };
  }
  const clamped = Math.max(0, Math.floor(months));
  if (clamped === 0) {
    return { years: null, months: null };
  }
  const years = Math.floor(clamped / 12);
  const remMonths = clamped % 12;
  return {
    years: years > 0 ? years : null,
    months: remMonths > 0 ? remMonths : null,
  };
};

export const combineYearsMonths = (
  years: number | null,
  months: number | null,
): number | null => {
  if (years === null && months === null) {
    return null;
  }
  const safeYears = clamp(years ?? 0, 0, MAX_EXPERIENCE_YEARS);
  const safeMonths = clamp(months ?? 0, 0, 11);
  const total = safeYears * 12 + safeMonths;
  return total === 0 ? null : total;
};

export const formatMonthsExperience = (
  months: number | null | undefined,
  t: TFunction,
): string => {
  if (months === null || months === undefined) {
    return '';
  }
  const { years, months: remMonths } = splitMonthsExperience(months);
  const parts: string[] = [];
  if (years && years > 0) {
    parts.push(t('skills.experience.yearsValue', { count: years }));
  }
  if (remMonths && remMonths > 0) {
    parts.push(t('skills.experience.monthsValue', { count: remMonths }));
  }
  if (parts.length === 0) {
    return t('skills.experience.monthsValue', { count: 0 });
  }
  return parts.join(' ');
};

const clamp = (value: number, min: number, max: number): number =>
  Math.min(Math.max(value, min), max);
